import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { productsService } from "api/services/products.service";
import ContentHeader from "components/Layout/ContentHeader";
import Badge from "components/UI/Badge";
import Button from "components/UI/Button";
import Table, { Column } from "components/UI/Table";

import type { ProductListItem } from "api/types/product.types";

import "pages/AdminPage.scss";

const ProductList: React.FC = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState<ProductListItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [searchInput, _setSearchInput] = useState("");

  useEffect(() => {
    setLoading(true);
    productsService
      .list({ search: search || undefined })
      .then((res) => {
        setProducts(res.data);
      })
      .catch(() => {
        /* ignore */
      })
      .finally(() => setLoading(false));
  }, [search]);

  const handleSearch = () => {
    setSearch(searchInput);
  };

  const _handleSearchKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") handleSearch();
  };

  const columns: Column<ProductListItem>[] = [
    {
      key: "images",
      title: "썸네일",
      width: "72px",
      render: (_val, row) => {
        const thumb = row.images?.find((i) => i.is_thumbnail) ?? row.images?.[0];
        return thumb ? (
          <img
            src={thumb.image}
            alt={row.name}
            style={{
              width: 48,
              height: 48,
              objectFit: "cover",
              borderRadius: 6,
              border: "1px solid #E4E4E7",
            }}
          />
        ) : (
          <div
            style={{
              width: 48,
              height: 48,
              borderRadius: 6,
              background: "#F4F4F5",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 10,
              color: "#A1A1AA",
            }}
          >
            없음
          </div>
        );
      },
    },
    {
      key: "brand",
      title: "브랜드",
      width: "100px",
      render: (_val, row) => (
        <div>
          <div style={{ fontWeight: 500, color: "#71717A" }}>{row.brand}</div>
          {/* {row.brand && (
            <div style={{ fontSize: 12, color: "#71717A", marginTop: 2 }}>{row.brand}</div>
          )} */}
        </div>
      ),
    },
    {
      key: "name",
      title: "상품명",
      render: (_val, row) => (
        <div>
          <div style={{ fontWeight: 500 }}>{row.name}</div>
          {/* {row.brand && (
            <div style={{ fontSize: 12, color: "#71717A", marginTop: 2 }}>{row.brand}</div>
          )} */}
        </div>
      ),
    },
    {
      key: "price",
      title: "정가",
      // width: "110px",
      render: (_val, row) => <span style={{ color: "#71717A" }}>{Number(row.price).toLocaleString("ko-KR")}원</span>,
    },
    {
      key: "discount_price",
      title: "판매가",
      // width: "110px",
      render: (_val, row) => (row.discount_price ? <span>{Number(row.discount_price).toLocaleString("ko-KR")}원</span> : <span style={{ color: "#A1A1AA" }}>-</span>),
    },
    {
      key: "discount_rate",
      title: "할인가",
      // width: "110px",
      render: (_val, row) => <span className="text-danger font-bold ">{row.discount_rate}%</span>,
    },
    {
      key: "is_active",
      title: "판매여부",
      // width: "90px",
      render: (_val, row) => <Badge variant={row.is_active ? "active" : "default"}>{row.is_active ? "판매 중" : "판매 중지"}</Badge>,
    },

    {
      key: "is_featured",
      title: "대표상품",
      // width: "70px",
      render: (_val, row) => (row.is_featured ? <Badge variant="info">대표</Badge> : null),
    },
  ];

  return (
    <div className="admin-page">
      <ContentHeader title="상품 목록" description="등록된 상품을 조회하고 수정할 수 있습니다." />

      <div style={{ margin: "20px 0", textAlign: "right" }}>
        <Button variant="primary" size="lg" onClick={() => navigate("/product-approval")}>
          상품 추가
        </Button>
      </div>

      {/* <Input
          placeholder='상품명 검색'
          value={searchInput}
          onChange={e => setSearchInput(e.target.value)}
          onKeyDown={handleSearchKeyDown}
          style={{ width: 240 }}
        /> */}
      {/* <Button variant='primary' size='sm' onClick={handleSearch}>검색</Button> */}
      {/* <span style={{ marginLeft: 'auto', fontSize: 14, color: '#71717A' }}>총 {products.length}개</span> */}

      <div className="admin-page__card">{loading ? <div style={{ padding: 40, textAlign: "center", color: "#71717A" }}>불러오는 중...</div> : <Table columns={columns} data={products} rowKey="id" onRowClick={(row) => navigate(`/product-edit/${row.id}`)} />}</div>

      <div style={{ marginTop: 16 }}>{/* <Pagination current={page} total={total} pageSize={PAGE_SIZE} onChange={p => setPage(p)} /> */}</div>
    </div>
  );
};

export default ProductList;
